import { RouteComponentProps } from "react-router";
import { interface___is_logged } from "../../../interfaces/interface.logged";
import { type___digitalmenu___theme } from "../../../types/types.theme";

//	P R O P S

export interface props___SbDigitalMenuEditAppearancePage extends RouteComponentProps<{ id: string; }>, interface___is_logged {

}

//	S T A T E

export interface state___SbDigitalMenuEditAppearancePage {

	digitalmenu___id: string,
	digitalmenu___props: any | null,
	digitalmenu___props___isLoading: boolean,

	theme___props: type___digitalmenu___theme,










	
}

//	S T A T E   D E F A U L T

export const state___SbDigitalMenuEditAppearancePage___default: state___SbDigitalMenuEditAppearancePage = {

	digitalmenu___id: '',
	digitalmenu___props: null,
	digitalmenu___props___isLoading: true,

	theme___props: {
		color___background: "#ffffff",
		color___foreground: "#333333",
		color___accent: "#cc3333",
		appearance___shadow: "unset",
		appearance___font_family: "\"Abel\", sans-serif",
		appearance___border_radius: 0
	},














	
}